import { render, staticRenderFns } from "./onKstp.vue?vue&type=template&id=0673cb2e"
import script from "./onKstp.vue?vue&type=script&lang=js"
export * from "./onKstp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports